import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { ReactElement, ReactNode } from 'react';

import { getLDClientSideId, getOrCreateLDClient, isLaunchDarklyConfigured } from './launchDarkly';
import {
    LD_FLAG_ENABLE_DEV_TOOLBAR,
    LD_FLAG_ENABLE_QUICKSIGHT_REPORTS,
    LD_FLAG_ENABLE_SESSION_REPLAY,
    LD_FLAG_USE_TASK_SYSTEM,
} from './launchDarklyFlags';

interface LaunchDarklyProviderProps {
    children: ReactNode;
}

/**
 * Renders `LDProvider` only when a client-side ID is configured. Without one, children still render
 * and `useFlags()` yields an empty set, so every flag falls back to its default.
 */
export const LaunchDarklyProvider = ({ children }: LaunchDarklyProviderProps): ReactElement => {
    if (!isLaunchDarklyConfigured()) {
        return <>{children}</>;
    }

    return (
        <LDProvider
            clientSideID={getLDClientSideId()}
            ldClient={getOrCreateLDClient()}
            reactOptions={{ useCamelCaseFlagKeys: false }}
            flags={{
                [LD_FLAG_USE_TASK_SYSTEM]: false,
                [LD_FLAG_ENABLE_SESSION_REPLAY]: false,
                [LD_FLAG_ENABLE_DEV_TOOLBAR]: false,
                [LD_FLAG_ENABLE_QUICKSIGHT_REPORTS]: false,
            }}
        >
            {children}
        </LDProvider>
    );
};
